module.exports = __webpack_public_path__ + "static/media/page_divider.ac119763.svg";